import { adminApi, SERVER_ERROR_MESSAGE, toAdminErrorMessage } from '../auth/adminApi';

// 별점·피드백 목록을 조회한다. rating이 'all'이면 전체. GET /admin/api/review/list?rating=1~5
export async function getReviews(rating) {
    let data;
    try {
        ({ data } = await adminApi.get('/admin/api/review/list', { params: rating === 'all' ? {} : { rating } }));
    } catch (error) {
        throw new Error(toAdminErrorMessage(error));
    }
    if (!Array.isArray(data)) throw new Error(SERVER_ERROR_MESSAGE);
    return data;
}

// 별점·피드백 상세를 조회한다. GET /admin/api/review/:id
export async function getReview(id) {
    try {
        const { data } = await adminApi.get(`/admin/api/review/${encodeURIComponent(id)}`);
        return data;
    } catch (error) {
        throw new Error(toAdminErrorMessage(error, '피드백을 찾을 수 없습니다.'));
    }
}
